import { render, staticRenderFns } from "./SignInTwitterAccountPage.vue?vue&type=template&id=2be9f544&scoped=true&"
import script from "./SignInTwitterAccountPage.vue?vue&type=script&lang=ts&"
export * from "./SignInTwitterAccountPage.vue?vue&type=script&lang=ts&"
import style0 from "./SignInTwitterAccountPage.vue?vue&type=style&index=0&id=2be9f544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9f544",
  null
  
)

export default component.exports